import {SortType} from "../constants/CreditOffersSortOptions";
import {ICreditOffer} from "../types/ICreditOffer";
import {getEffectiveInterestRate} from "./get_effective_interest_rate";

export const sortCreditOffers = (offers: ICreditOffer[], type: SortType) => {
    const offersToSort = offers.filter((offer) => offer.equal_installment_rate > 0);

    switch (type) {
        case SortType.PERCENT_DOWN:
            return offersToSort
                .filter((offer) => getEffectiveInterestRate(offer) > 0)
                .sort((prev, next) => getEffectiveInterestRate(next) - getEffectiveInterestRate(prev));
        case SortType.PERCENT_UP:
            return offersToSort
                .filter((offer) => getEffectiveInterestRate(offer) > 0)
                .sort((prev, next) => getEffectiveInterestRate(prev) - getEffectiveInterestRate(next));
        case SortType.RRSO_DOWN:
            return offersToSort.sort((prev, next) => next.rrso - prev.rrso);
        case SortType.RRSO_UP:
            return offersToSort.sort((prev, next) => prev.rrso - next.rrso);
        case SortType.COMMISSION_DOWN:
            return offersToSort.sort((prev, next) => next.commission - prev.commission);
        case SortType.COMMISSION_UP:
            return offersToSort.sort((prev, next) => prev.commission - next.commission);
        case SortType.COSTS:
            return offersToSort.sort((prev, next) => prev.all_costs_sum - next.all_costs_sum);
        case SortType.INSTALMENT_RATE:
        default:
            return offersToSort.sort((prev, next) => prev.equal_installment_rate - next.equal_installment_rate);
    }
};
import {SortType} from "../constants/CreditOffersSortOptions";
import {ICreditOffer} from "../types/ICreditOffer";
import {getEffectiveInterestRate} from "./get_effective_interest_rate";

export const sortCreditOffers = (offers: ICreditOffer[], type: SortType) => {
    const offersToSort = offers.filter((offer) => offer.equal_installment_rate > 0);

    switch (type) {
        case SortType.PERCENT_DOWN:
            return offersToSort
                .filter((offer) => getEffectiveInterestRate(offer) > 0)
                .sort((prev, next) => getEffectiveInterestRate(next) - getEffectiveInterestRate(prev));
        case SortType.PERCENT_UP:
            return offersToSort
                .filter((offer) => getEffectiveInterestRate(offer) > 0)
                .sort((prev, next) => getEffectiveInterestRate(prev) - getEffectiveInterestRate(next));
        case SortType.RRSO_DOWN:
            return offersToSort.sort((prev, next) => next.rrso - prev.rrso);
        case SortType.RRSO_UP:
            return offersToSort.sort((prev, next) => prev.rrso - next.rrso);
        case SortType.COMMISSION_DOWN:
            return offersToSort.sort((prev, next) => next.commission - prev.commission);
        case SortType.COMMISSION_UP:
            return offersToSort.sort((prev, next) => prev.commission - next.commission);
        case SortType.COSTS:
            return offersToSort.sort((prev, next) => prev.all_costs_sum - next.all_costs_sum);
        case SortType.INSTALMENT_RATE:
        default:
            return offersToSort.sort((prev, next) => prev.equal_installment_rate - next.equal_installment_rate);
    }
};
